/*
- Get All polices assign
- Check what
 */

import { db } from "@/lib/firebase";
import { collection, doc, getDoc, getDocs, setDoc, Timestamp, DocumentReference, query, orderBy } from 'firebase/firestore';
import { AssignedQuizzes } from '@/app/pages/policy-reader/components/columns';
import { string } from 'zod';
import { renderCtx } from '@/utils/ctxRenderer';

export async function getUserAssignedPolicies(uid: string, cid: string) {
  const docRef = collection(db, "users", uid, "assignedPolicies");
  const colSnap = await getDocs(docRef);

  if (colSnap.empty) return [];

  const policyRefs = colSnap.docs.map((d) =>
    doc(db, `customers/${cid}/product/policyPackages/policies/${d.id}`)
  );

  const snaps = await Promise.all(policyRefs.map((r) => getDoc(r)));

  const policies = snaps
    .filter((s) => s.exists())
    .map((s) => ({ id: s.id, ...s.data() }))
    // Keep only policies that have a non-empty DocumentReference in `quiz_location`
    .filter((p: any) => {
      const ql = (p as any).quiz_location as any;
      return !!ql && typeof ql === "object" && typeof (ql as any).path === "string" && (ql as any).path.trim().length > 0;
    });

  return colSnap.docs
    // Only keep assignments that have a matching policy with a quiz
    .filter((d) => policies.some((p: any) => p.id === d.id))
    .map((d) => {
      const data: any = d.data();
      const policy: any | undefined = policies.find((p: any) => p.id === d.id);
      return {
        id: d.id,
        name: policy?.policy_name ?? "(Unnamed policy)",
        status: (data.completed === true || data.completed === "true") ? "Completed" : "Not Completed",
        // TODO: replace with real progress; placeholder 0..100
        progress: Math.floor(Math.random() * 101),
      } as AssignedQuizzes;
    });
}

export interface PolicyQuizItem {
  title: string;
  description: string;
  status: string;
  latest_version: DocumentReference;
  questions: PolicyQuizQuestion[];
}

export interface PolicyQuizQuestion {
  id: string;
  correct_answers: string[];
  explanation: string;
  text: string;
  options: PolicyQuizOptions[];
  type: string;
  order: number;
}

export interface PolicyQuizOptions {
  id: string;
  text: string;
}

export async function getQuizzesForPolicy(company, user, policyId: string): Promise<PolicyQuizItem> {
  const docRef = doc(db, "customers", company.id, "product/policyPackages/policies", policyId);

  console.log('[getQuizzesForPolicy]', docRef);

  const snapPolicy = await getDoc(docRef);
  console.log('[getQuizzesForPolicy]', snapPolicy);

  const policyData = snapPolicy.data();

  console.log('[getQuizzesForPolicy]', 'location', policyData, policyData.quiz_location);

  const quiz = await getDoc(policyData.quiz_location);

  console.log('[getQuizzesForPolicy]', company, user, docRef, snapPolicy.data());
  if (!quiz.exists()) throw new Error(`Quiz at ${docRef} is not found or empty!`);

  const verRef = quiz.get('latest_version');
  if (!verRef) throw new Error('Unable to get latest version!');

  const qCol = collection(db, verRef.path, "questions");
  const qQuery = query(qCol, orderBy("order", "asc"));
  const qSnap = await getDocs(qQuery);

  const ctx =  { company: { name: company.name }, user: { name: user.name }};
  const rawQuestions: PolicyQuizOptions[] = qSnap.docs.map((d) => {
    const data = d.data() as Omit<PolicyQuizOptions, "id">; // everything except id
    return { id: d.id, ...renderCtx(ctx, data) };
  });

  console.log('[getQuizzesForPolicy]', 'qSnap', qCol.path, qSnap.docs, rawQuestions, quiz.id);

  const data = quiz.data();

  return {
    ...data,
    id: quiz.id,
    timeLimit: 0,
    questions: rawQuestions,
  } as PolicyQuizItem;

}

export async function saveQuizAttempt(company: any, user: any, quiz: any, attempt) {
  console.log('[saveQuizAttempt]', company, user, quiz, attempt);

  const docRef = doc(
    db,
    "users",
    user.uid,
    "assignedPolicies",
    attempt.policyId,
    "policy_quiz_results",
    "results"
  );

  // const docd = await getDoc(docRef);
  //
  // console.log('[saveQuizAttempt]', docRef, docd.data());

  const data = {
    answers: attempt.answers,
    startTime: attempt.startTime,
    endTime: attempt.endTime,
    timeSpent: attempt.timeSpent,
    score: attempt.score,
    quizId: attempt.quizId,
    policyId: attempt.policyId,
    passed: attempt.passed,
  };
  console.log('[saveQuizAttempt]', data);

  await setDoc(
    docRef,
    {
      [attempt.id]: data
    },
    { merge: true }
  );

  if (attempt.passed) {
    await setDoc(
      doc(db,"users", user.uid, "assignedPolicies", attempt.policyId),
      {
        'completed': true,
      },
      { merge: true }
    )
  }
}

export async function getCurrentScreenForPolicy(
  user: any,
  policyId: string
): Promise<number | null> {
  const userPolicyRef = doc(db, "users", user.uid, "assignedPolicies", policyId);
  const userPolicyDoc = await getDoc(userPolicyRef);

  if (!userPolicyDoc.exists()) {
    console.log("[getCurrentScreenForPolicy] Document does not exist");
    return null;
  }

  const data = userPolicyDoc.data();
  console.log("[getCurrentScreenForPolicy]", data);

  return data?.currentScreen ?? 1; // return 1 if missing
}

export async function setCurentScreenForPolicy(
  user: any,
  policyId: string,
  page: number
): Promise<boolean> {
  console.log("[setCurrentScreenForPolicy]", user, policyId, page);
  try {
    const policyRef = doc(db, `users/${user.uid}/assignedPolicies/${policyId}`);
    await setDoc(policyRef, { currentScreen: page }, { merge: true });

    console.log('[setCurrentScreenForPolicy]', `Set to ${page}`);

    return true;
  } catch (error) {
    console.error("Failed to set currentScreen:", error);
    return false;
  }
}
